(function(){
  if(window.__sqCollectionRailCascadeV1)return;
  window.__sqCollectionRailCascadeV1=true;
  /* SEP 27 2026: every category / subcategory now owns its own nested panel, so any number of
     branches can be expanded at the same time (click the + on each one). Loaded branches are cached. */
  function boot(){
    var rail=document.querySelector('[data-sq-collection-rail][data-sq-department-root="true"]');
    if(!rail)return;
    if(rail.dataset.sqStateGuardComponentRoot==='true')return;
    var catItem=rail.querySelector('[data-sq-context-categories]');
    var catList=rail.querySelector('[data-sq-context-categories-list]');
    if(!catItem||!catList)return;
    var flyout=catItem.querySelector(':scope > .sq-collection-rail__flyout');
    var inner=flyout&&flyout.querySelector('.sq-collection-rail__flyout-inner');
    if(!flyout||!inner)return;
    catItem.classList.add('sq-collection-rail__item--cascade');
    var cache={};
    function cleanLabel(a){
      var n=a.querySelector('.sq-subcategory-name,.sq-third-level__name,.sq-ts-match-name,.sq-books-tree__copy strong,.sq-ptype-browser__name,.vac-service-card__name,.vac-armor-browser__name,strong,h3');
      return String(n?n.textContent:a.textContent||'').replace(/\b\d[\d,]*\s+(?:items?|products?)\b/ig,'').replace(/\s+/g,' ').trim();
    }
    function countText(a){
      var n=a.querySelector('.sq-subcategory-count,.sq-third-level__type-count,.sq-ts-match-count,.sq-books-tree__copy small,.sq-ptype-browser__card-count,.vac-service-card__meta,.vac-armor-browser__meta');
      return n?String(n.textContent||'').replace(/\s+/g,' ').trim():'';
    }
    function row(a){
      var href=a.getAttribute('href')||'';var label=cleanLabel(a),count=countText(a);if(!href||!label)return null;
      if(/^\s*0\s*(?:items?|products?)?\s*$/i.test(count)||/\b0\s+(?:items?|products?)\b/i.test(count))return null;
      try{var u=new URL(href,location.origin);return {href:u.pathname+u.search,label:label,count:count}}catch(_){return null}
    }
    function unique(rows){
      var seen={};return rows.filter(function(r){if(!r)return false;var k=r.href+'|'+r.label;if(seen[k])return false;seen[k]=1;return true});
    }
    function parse(doc){
      var subs=[],types=[],direct=[];
      doc.querySelectorAll('.sq-subcategory-section:not([data-sq-root-rail-source]) .sq-subcategory-card[href],.vac-uniform-insignia-button__link[href]').forEach(function(a){subs.push(row(a))});
      doc.querySelectorAll('.sq-third-level .sq-third-level__type[href],.sq-thin-stabrite-types .sq-ts-match-card[href],.sq-books-tree[data-mode="type"] .sq-books-tree__card[href],.sq-ptype-browser__card[href],.vac-service-card[href],.vac-armor-browser__card[href],.vac-knives-browser__button[href]').forEach(function(a){direct.push(row(a))});
      doc.querySelectorAll('.sqbfl-grid .sqbfl-card[href]').forEach(function(a){
        var r=row(a);if(!r)return;
        try{
          var u=new URL(r.href,location.origin);
          if(u.searchParams.has('sq_bfl_type'))direct.push(r);
          else if(u.searchParams.has('sq_bfl_subcategory'))subs.push(r);
          else if(u.searchParams.has('sq_bfl_category'))subs.push(r);
        }catch(_e){}
      });
      doc.querySelectorAll('input[name="filter.p.product_type"]').forEach(function(input){
        if(input.disabled)return;
        var label='',linked=null;
        if(input.id){try{linked=doc.querySelector('label[for="'+CSS.escape(input.id)+'"]')}catch(_e){}}
        if(linked)label=linked.textContent||'';
        if(!label){var wrapped=input.closest&&input.closest('label');if(wrapped)label=wrapped.textContent||''}
        var rawLabel=String(label||input.value||'');
        if(/\(\s*0\s*\)|\b0\s+(?:items?|products?)\b/i.test(rawLabel))return;
        label=rawLabel.replace(/\b\d+\s*(?:items?|products?)\b/ig,'').replace(/\s+/g,' ').trim();
        if(label&&input.value){
          var u=new URL(doc.location&&doc.location.href?doc.location.href:location.href,location.origin);
          var bits=u.pathname.replace(/^\/+|\/+$/g,'').split('/'),head=bits.slice(0,2),tail=bits.slice(2).join('/');
          var tags=tail?tail.split('+').filter(Boolean):[];
          tags=tags.filter(function(x){return !/^sq-type-/i.test(x)});
          var typeHandle=String('SQ Type: '+input.value).toLowerCase().trim().replace(/['’‘]/g,'').replace(/[^a-z0-9]+/g,'-').replace(/^-+|-+$/g,'');
          if(tags.indexOf(typeHandle)===-1)tags.push(typeHandle);
          u.pathname='/'+head.concat(tags.length?[tags.join('+')]:[]).join('/');
          u.searchParams.delete('filter.p.product_type');u.searchParams.delete('page');
          if(!u.searchParams.has('filter.v.availability'))u.searchParams.set('filter.v.availability','1');
          types.push({href:u.pathname+'?'+u.searchParams.toString(),label:label,count:''});
        }
      });
      return {subcategories:unique(subs),types:unique(types),direct:unique(direct)};
    }
    function fetchHierarchy(href){
      var key=href;if(cache[key])return cache[key];
      var u=new URL(href,location.origin),category=u.searchParams.get('sq_bfl_category')||'',subcategory=u.searchParams.get('sq_bfl_subcategory')||'';
      if(category&&window.__sqBflSidebarApi&&window.__sqBflSidebarApi.ready){
        cache[key]=window.__sqBflSidebarApi.ready.then(function(){var d=window.__sqBflSidebarApi.hierarchy(category,subcategory)||{};return {subcategories:unique((d.subcategories||[]).map(function(x){return {href:x.href,label:x.label,count:''}})),types:unique((d.types||[]).map(function(x){return {href:x.href,label:x.label,count:''}})),direct:[]}}).catch(function(){return {subcategories:[],types:[],direct:[]}});
        return cache[key];
      }
      var pv=new URL(location.href).searchParams.get('preview_theme_id');
      if(pv)u.searchParams.set('preview_theme_id',pv);
      if(!u.searchParams.has('filter.v.availability'))u.searchParams.set('filter.v.availability','1');
      cache[key]=fetch(u.pathname+u.search,{credentials:'same-origin'}).then(function(r){if(!r.ok)throw new Error(String(r.status));return r.text()}).then(function(html){return parse(new DOMParser().parseFromString(html,'text/html'))}).catch(function(){return {subcategories:[],types:[],direct:[]}});
      return cache[key];
    }
    function render(list,rows,kind){
      var frag=document.createDocumentFragment();
      rows.forEach(function(r){
        var li=document.createElement('li'),a=document.createElement('a'),s=document.createElement('span');
        a.href=r.href;a.dataset.sqCascadeKind=kind;s.className='sq-collection-rail__link-label';s.textContent=r.label;a.appendChild(s);
        if(r.count&&rail.dataset.sqDepartmentRoot!=='true'){var small=document.createElement('small');small.className='sq-collection-rail__link-count';small.textContent=r.count;a.appendChild(small)}
        li.appendChild(a);frag.appendChild(li);
      });
      list.replaceChildren(frag);
    }
    /* Every expanded branch starts with a "Shop All <branch>" leaf so untagged products stay reachable. */
    function addShopAll(list,source){
      if(!list||!source)return;
      var label=String(source.textContent||'').replace(/\s+/g,' ').trim();
      var href=source.getAttribute('href')||source.href||'';
      if(!label||!href)return;
      var li=document.createElement('li'),a=document.createElement('a'),s=document.createElement('span');
      a.href=href;a.dataset.sqCascadeKind='type';a.className='sq-collection-rail__shop-all-leaf';
      s.className='sq-collection-rail__link-label';s.textContent='Shop All '+label;a.appendChild(s);
      li.appendChild(a);list.insertBefore(li,list.firstChild);
    }
    function makePanel(kind){
      var s=document.createElement('section'),sub=kind==='sub';
      s.className='sq-collection-rail__cascade-column';
      s.setAttribute(sub?'data-sq-cascade-subcategories':'data-sq-cascade-types','');
      s.innerHTML='<h2>'+(sub?'Subcategories':'Types')+'</h2><p class="sq-collection-rail__cascade-note"></p><ul class="sq-collection-rail__links" role="list" '+(sub?'data-sq-cascade-subcategory-list':'data-sq-cascade-type-list')+'></ul>';
      return s;
    }
    function panelFor(host,kind){
      var attr=kind==='sub'?'data-sq-cascade-subcategories':'data-sq-cascade-types';
      var p=host.querySelector(':scope > ['+attr+']');
      if(!p){p=makePanel(kind);host.appendChild(p)}
      return p;
    }
    function setNote(col,text){var p=col.querySelector('.sq-collection-rail__cascade-note');if(p)p.textContent=text}
    function openLink(a){a.classList.add('is-cascade-active');a.setAttribute('aria-expanded','true')}
    function seedCategoriesFromBfl(){
      if(catList.dataset.sqBflCanonicalSeeded==='true')return;
      var api=window.__sqBflSidebarApi;
      if(!api||!api.ready||!api.categories)return;
      api.ready.then(function(){
        if(catList.dataset.sqBflCanonicalSeeded==='true')return;
        var rows=api.categories()||[],frag=document.createDocumentFragment();
        rows.forEach(function(r){
          if(!r||!r.href||!r.label)return;
          var li=document.createElement('li'),a=document.createElement('a'),s=document.createElement('span');
          a.href=r.href;s.className='sq-collection-rail__link-label';s.textContent=r.label;a.appendChild(s);li.appendChild(a);frag.appendChild(li);
        });
        if(rows.length){catList.replaceChildren(frag);catList.dataset.sqBflCanonicalSeeded='true';catItem.hidden=false}
      }).catch(function(){});
    }
    seedCategoriesFromBfl();
    window.addEventListener('sq:bfl-api-ready',seedCategoriesFromBfl);
    function loadCategory(a){
      if(!a||!a.href)return Promise.resolve(false);
      var host=a.closest('li');if(!host)return Promise.resolve(false);
      var panel=panelFor(host,'sub'),list=panel.querySelector('[data-sq-cascade-subcategory-list]');
      panel.hidden=false;openLink(a);
      if(panel.dataset.sqLoaded==='1')return Promise.resolve(panel.dataset.sqHasChildren==='true');
      setNote(panel,'Loading…');
      return fetchHierarchy(a.href).then(function(data){
        var subs=data.subcategories||[],direct=data.direct||[],types=data.types||[],has=false;
        if(subs.length){
          panel.querySelector('h2').textContent='Subcategories';render(list,subs,'subcategory');has=true;
        }else if(types.length||direct.length){
          panel.querySelector('h2').textContent='Types';render(list,types.length?types:direct,'type');has=true;
        }else{
          panel.querySelector('h2').textContent='Subcategories';list.replaceChildren();
        }
        addShopAll(list,a);
        setNote(panel,has?'':'No additional subcategories.');
        panel.dataset.sqLoaded='1';panel.dataset.sqHasChildren=has?'true':'false';
        return has;
      });
    }
    function loadSubcategory(a){
      if(!a||!a.href||a.dataset.sqCascadeKind!=='subcategory')return Promise.resolve(false);
      catItem.classList.add('is-open');
      var host=a.closest('li');if(!host)return Promise.resolve(false);
      var panel=panelFor(host,'type'),list=panel.querySelector('[data-sq-cascade-type-list]');
      panel.hidden=false;openLink(a);
      if(panel.dataset.sqLoaded==='1')return Promise.resolve(panel.dataset.sqHasChildren==='true');
      setNote(panel,'Loading…');
      return fetchHierarchy(a.href).then(function(data){
        var rows=(data.types&&data.types.length)?data.types:((data.direct&&data.direct.length)?data.direct:[]);
        if(rows.length)render(list,rows,'type');else list.replaceChildren();
        addShopAll(list,a);
        setNote(panel,rows.length?'':'No additional product types.');
        panel.dataset.sqLoaded='1';panel.dataset.sqHasChildren=rows.length?'true':'false';
        return rows.length>0;
      });
    }
    window.__sqSidebarTreeDataApis=window.__sqSidebarTreeDataApis||{};
    window.__sqSidebarTreeDataApis.generic={
      mode:'generic',
      multiOpen:true,
      activateCategory:loadCategory,
      activateSubcategory:loadSubcategory,
      categoryList:catList,
      categoryItem:catItem
    };
    window.__sqSidebarTreeDataApi=window.__sqSidebarTreeDataApis.generic;
    window.dispatchEvent(new CustomEvent('sq:sidebar-tree-data-ready',{detail:{mode:'generic'}}));
    /* Interaction ownership: sq-sidebar-tree-controller-v2.js. */
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
})();
